export default __webpack_public_path__ + "static/media/orangeBig.d3dfb365.svg";